import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './pages/Main.jsx';
import RentPage from './pages/RentPage.jsx';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/Rent" element={<RentPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;